import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

const timeSeriesDataPointSchema_ = z.object({
  date: z.string(),
  count: z.number(),
});
export const timeSeriesDataPointSchema: z.ZodType<TimeSeriesDataPoint> =
  timeSeriesDataPointSchema_;
export interface TimeSeriesDataPoint
  extends z.infer<typeof timeSeriesDataPointSchema_> {}

const gradeTimeSeriesSchema_ = z.object({
  grade: z.string(),
  data: z.array(timeSeriesDataPointSchema),
});
export const gradeTimeSeriesSchema: z.ZodType<GradeTimeSeries> =
  gradeTimeSeriesSchema_;
export interface GradeTimeSeries
  extends z.infer<typeof gradeTimeSeriesSchema_> {}

const returnsCenterLocationSchema_ = z.object({
  id: z.string(),
  name: z.string(),
});
export const returnsCenterLocationSchema: z.ZodType<ReturnsCenterLocation> =
  returnsCenterLocationSchema_;
export interface ReturnsCenterLocation
  extends z.infer<typeof returnsCenterLocationSchema_> {}

export const getManagedReturnsMetrics = unaryRpc({
  name: "getManagedReturnsMetrics" as const,
  input: z.object({
    startDate: z.date(),
    endDate: z.date(),
    locationId: z.string().optional(),
  }),
  output: z.object({
    managedReturnsCount: z.number(),
    completeReturns: z.number(),
    inTransitReturns: z.number(),
    deliveredReturns: z.number(),
    processedReturnsCount: z.number(),
    totalItemsProcessed: z.number(),
    averageProcessingDays: z.number().nullable(),
    processedReturnsOverTime: z.array(
      timeSeriesDataPointSchema_.extend({
        averageProcessingDays: z.number().nullable(),
      }),
    ),
    gradeDistributionOverTime: z.array(gradeTimeSeriesSchema),
    returnsCenterLocations: z.array(returnsCenterLocationSchema),
  }),
});
